<template>
    <div class="flex flex-col md:flex-row md:items-end w-full justify-between">
        <div >
            <span @click="goToAddUser" class="btn btn--red-1">
                <i class="far fa-plus text-lg mr-2"></i> Add User
            </span>
        </div>
        <div class="mt-4 md:mt-0">
            <div class="flex border border-blue-gray rounded-3xl pl-5 pr-5 py-1 py-2 items-center">
                <input @change="reloadClients" v-model="searchString" type="text" placeholder="Search User"
                       class="w-full md:w-56 text-sm font-light bg-transparent outline-none"> <i
                    class="far fa-search text-blue-gray"></i>
            </div>
        </div>
    </div>

    <div class="bg-white shadow-100 rounded-xl mt-4" >
        <div class="equipment-row grid-cols-1 md:grid-cols-9 items-center hidden md:grid py-3 px-7">
            <div class="style-title-1 md:col-span-2">
                Name
            </div>
            <div class="style-title-1 md:col-span-3">
                Email
            </div>
            <div class="style-title-1 col-span-1">
                Status
            </div>
            <div class="style-title-1 col-span-1">
                Role
            </div>

            <div class="text-center style-title-1 md:col-span-2">
                Action
            </div>
        </div>

        <div v-for="user in searchResult"
             class="equipment-row grid grid-cols-1 md:grid-cols-9 items-center py-5 px-7" :key="user.id">
            <div class="py-1 flex md:col-span-2">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Name:
                </div>
                <div>
                    {{ user.first_name }} {{ user.last_name }}
                </div>
            </div>
            <div class="py-1 flex md:col-span-3">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Email:
                </div>
                <div>
                    {{ user.email }}
                </div>
            </div>

            <div class="py-1 flex col-span-1">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Status
                </div>
                <div class="capitalize">
                <span v-if="user.status == 'active'" >
                    Enabled
                </span>
                    <span v-if="user.status == 'inactive'" >
                    Disabled
                </span>
                </div>
            </div>


            <div class="py-1 flex col-span-1">
                <div class="style-title-1 w-1/4 text-right mr-3 md:hidden">
                    Role
                </div>
                <div class="capitalize">
                     <span v-if="user.role == 'group-admin'" >
                        Group Admin
                    </span>
                    <span v-if="user.role == 'user'" >
                        Standard User
                    </span>
                    <span v-if="user.role == 'manager'" >
                        Account Admin
                    </span>
                </div>
            </div>


            <div class="text-right md:text-center mt-4 md:mt-0 md:col-span-2">
                <toggle-menu>
                    <div @click="goToEditUser(user)" class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray">
                        <i class="fal fa-pencil text-lg mr-3 "></i> Edit User
                    </div>

                    <div class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray"
                         @click="resetPassword(user.id)">
                        <i class="fal fa-sync text-lg mr-3"></i> Reset Password
                    </div>

                    <div v-if="user.id != profile.getUser().id">
                        <div v-if="user.status == 'active'"
                             class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray"
                             @click="changeStatus(user, 'inactive')"   >
                            <i class="fal fa-times text-lg mr-3 text-red"></i> Disable User
                        </div>
                        <div v-else
                             class="py-1 px-4 flex items-center style-body font-light cursor-pointer hover:bg-gray"
                             @click="changeStatus(user, 'active')"   >
                            <i class="fal fa-check text-lg mr-3 text-success"></i> Enable User
                        </div>
                    </div>
                </toggle-menu>
            </div>
        </div>
    </div>


    <div class="text-center mt-5" :class="{hidden: !loading}">
        <loading></loading>
    </div>


</template>

<script charset="utf-8">

import Loading from './Loading.vue';
import ToggleMenu from './ToggleMenu.vue';
import Vuex from 'vuex';

export default {
    props: ['title', 'toAddress'],
    data() {
        return {
            curPage: 0,
            loading: false,
            searchString: ''
        }
    },
    computed: {
        ...Vuex.mapGetters('profile', {
            profile: 'profile'
        }),
        ...Vuex.mapGetters('accounts', {
            users: 'users'
        }),
        searchResult: function () {
            if (this.searchString === '') {
                return this.users;
            }

            let searchTermLowerCase = this.searchString.toLowerCase();

            return this.users.filter(item => {
                let data = [
                    item.first_name, item.last_name, item.email, item.phone
                ];
                if(JSON.stringify(data).toLowerCase().includes(searchTermLowerCase)){
                    return item;
                }
            })
        },
    },
    created() {
        this.loading = true;

        let params = { searchString: this.searchString, role: this.profile.getRole() };
        if(this.profile.isSharpAdmin() || this.profile.isGroupAdmin() ){
            params.clientID = this.$router.currentRoute.value.params.clientID;
        }

        this.getUsers(params).then(() => {
            this.loading = false;
        });
    },
    components: {
        Loading,
        ToggleMenu
    },

    methods: {
        ...Vuex.mapMutations('accounts', {
            setSelectedUser: 'setSelectedUser'
        }),
        ...Vuex.mapActions('accounts', {
            getUsers: 'getUsers',
            updateUser: 'updateUser',
            updateUserStatus: 'updateUserStatus',
            resetPasswordUser: 'resetPasswordUser',
        }),

        resetPassword(userID){
            this.$toast.info('Reset password email has been sent');
            this.resetPasswordUser({userID: userID});
        },
        changeStatus(user, newStatus){
            let data = {
                id: user.id,
                status: newStatus
            };

            user.status = newStatus;
            if(newStatus == 'inactive'){
                this.$toast.info('Selected user has been disabled');
            }else{
                this.$toast.info('Selected user has been enabled');
            }

            this.updateUserStatus(data);
        },
        goToEditUser(user){
            this.setSelectedUser(user);
            if(this.profile.isSharpAdmin()){
                this.$router.push({ name: 'adminUserEdit', params: { userID: user.id }});
            } else if(this.profile.isGroupAdmin()){
                this.$router.push({ name: 'groupAdminUserEdit', params: { userID: user.id }});
            } else{
                this.$router.push({ name: 'managerUserEdit', params: { userID: user.id }});
            }
        },
        goToAddUser(){
            if(this.profile.isSharpAdmin()){
                this.$router.push({ name: 'adminUserAdd'});
            } else if(this.profile.isGroupAdmin()){
                this.$router.push({ name: 'groupAdminUserAdd'});
            } else{
                this.$router.push({ name: 'managerUserAdd'});
            }
            //clientsUserAdd
        }
    }
}
</script>
